import apiClient from './client';

export type Priority = 'normal' | 'important' | 'urgent';
export interface NotificationDraft {
  body_format?: 'plain' | 'markdown'; version?: number; title: string; body: string; category: string; priority: Priority;
  audience: 'all' | 'users'; user_ids: string[]; pinned: boolean;
}
export interface Notification extends NotificationDraft {
  id: string; status: 'draft' | 'published' | 'withdrawn'; created_at: string;
  updated_at: string; published_at: string | null; read_at: string | null;
  recipient_count: number; read_count: number;
}
export interface NotificationUser { id: string; name: string; email: string }
export interface NoticePage { list: Notification[]; total: number; total_page: number }
const root = '/admin/notifications';
async function get<T>(url: string, params?: object): Promise<T> {
  return (await apiClient.get<{ data: T }>(url, { params })).data.data;
}
async function post<T>(url: string, data?: unknown): Promise<T> {
  return (await apiClient.post<{ data: T }>(url, data)).data.data;
}
export const notificationAPI = {
  pending: (cursor = '') => get<NoticePage>('/notifications/pending', { cursor }),
  list: (page: number, status = '', admin = false, size = 20) => get<NoticePage>(admin ? root : '/notifications', { page, size, status }),
  users: (q: string) => get<NotificationUser[]>(root + '/users', { q }),
  preview: (draft: NotificationDraft) => post<{ recipient_count: number }>(root + '/preview', draft),
  save: async (draft: NotificationDraft, id?: string) => id
    ? (await apiClient.put<{ data: { id: string; version: number } }>(root + '/' + id, draft)).data.data
    : post<{ id: string; version: number }>(root, draft),
  publish: (id: string, version: number) => post(root + '/' + id + '/publish', { version }),
  withdraw: (id: string) => post(root + '/' + id + '/withdraw'),
  read: (id: string, method: 'auto_display' | 'manual_ack' | 'bulk_manual') => post('/notifications/' + id + '/read', { method }),
};
